module.exports = __webpack_public_path__ + "img/img38.72efe4f8.svg";